import { EventRepository } from '../repositories/EventRepository';
import { events } from '@estee/elc-service-bus';
import { Event } from '../domain/entities/Event';
import { diContainer, serviceNames } from '../../service-setup/diContainer';

export class AppointmentAddedToCalendarUseCase {
    private eventRepository: EventRepository;

    constructor() {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
    }

    public execute = async () => {
        const appointmentAddedToCalendarPayload = {
            event_name: 'appointment booking',
            event_category: 'appointment booking',
            event_action: 'completion page interaction',
            event_label: 'save to calendar'
        };

        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: events.APPOINTMENT_ADDED_TO_CALENDAR,
            type: 'link',
            payload: appointmentAddedToCalendarPayload
        });

        this.eventRepository.addEventToQueue(newEvent);
    };
}
